import {
  estimateMatterStatute,
  type StatuteEstimateInput,
} from "@/lib/data/requests/matters/statute-estimate";

export const statuteEstimateQueryOptions = (
  input: StatuteEstimateInput,
  matterVersion: string,
) => ({
  queryKey: ["matterStatuteEstimate", input, matterVersion],
  queryFn: () => estimateMatterStatute(input),
  enabled: false,
  retry: false,
  staleTime: 0,
});
